export default __webpack_public_path__ + "static/media/tip_bottom_select.8aba2a02.png";